import Application from '3-foundation/Application/ApplicationEntity';

export const getSearchSiteId = (siteId: string): string => {
	const searchSiteId =
		Application?.envVars?.NEXT_PUBLIC_SEARCH_SITE_ID_OVERRIDE === true ? (Application.envVars.NEXT_PUBLIC_SEARCH_SITE_ID as string) : siteId;
	return Application?.envVars?.NEXT_PUBLIC_SEARCH_SITE_ENV ? Application?.envVars?.NEXT_PUBLIC_SEARCH_SITE_ENV + '-' + searchSiteId : searchSiteId;
};
